<div class="flex flex-col w-full h-full" matAutocompleteOrigin>
  <label
    class="text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label"
    *ngIf="label"
    >{{ label }}</label
  >
  <div
    class="flex relative flex-row gap-2 px-2 py-0 w-full border border-cool-gray-300 ts-input min-h-ts-field-height align-center"
    [ngClass]="{
      'bg-white': control?.enabled && backgroundColor === 'white',
      slim: variant === 'slim',
      large: size === 'lg',
      sm: size === 'sm',
      ss: size === 'ss',
      invalid: control?.invalid && control?.touched,
    }"
  >
    <ts-icon [ngStyle]="{ width: 'fit-content' }" *ngIf="icon" [icon]="icon" color="black"></ts-icon>
    @if (autoCompleteComponentRef) {
      <input
        #inputElement
        class="w-full"
        [ngClass]="{ blurred: blurred }"
        [readonly]="readonly || blurred"
        [attr.data-cy]="dataCy"
        [autofocus]="autofocus"
        [type]="inputType"
        [tabIndex]="tabindex"
        [placeholder]="placeholder"
        [formControl]="control"
        [autocomplete]="autocomplete"
        [maxlength]="maxlength"
        [min]="moneyMin || min"
        [max]="moneyMax || max"
        [step]="step"
        [matAutocompletePosition]="'auto'"
        [matAutocomplete]="matAutocompleteComponentRef"
        [matAutocompleteDisabled]="!autoCompleteComponentRef"
        (blur)="onInputBlur()"
      />
    } @else if (mask) {
      <input
        #inputElement
        class="w-full"
        [ngClass]="{ blurred: blurred }"
        [readonly]="readonly || blurred"
        [attr.data-cy]="dataCy"
        [autofocus]="autofocus"
        [type]="inputType"
        [tabIndex]="tabindex"
        [placeholder]="placeholder"
        [formControl]="control"
        [autocomplete]="autocomplete"
        [maxlength]="maxlength"
        [min]="moneyMin || min"
        [max]="moneyMax || max"
        [step]="step"
        [mask]="mask"
        (blur)="onInputBlur()"
      />
    } @else {
      <input
        #inputElement
        class="w-full"
        [ngClass]="{ blurred: blurred }"
        [readonly]="readonly || blurred"
        [attr.data-cy]="dataCy"
        [autofocus]="autofocus"
        [type]="inputType"
        [tabIndex]="tabindex"
        [placeholder]="placeholder"
        [formControl]="control"
        [autocomplete]="autocomplete"
        [maxlength]="maxlength"
        [min]="moneyMin || min"
        [max]="moneyMax || max"
        [step]="step"
        (blur)="onInputBlur()"
      />
    }
    <ts-icon
      class="absolute top-1/2 left-full transform scale-90 -translate-x-6 -translate-y-1/2 cursor-pointer focus:outline-black w-fit-content"
      tabindex="0"
      *ngIf="clearable && control?.value"
      icon="ts_close"
      color="light-gray"
      (click)="control.setValue('')"
      (keydown.enter)="control.setValue('')"
    ></ts-icon>
    <ng-content select="[ts-autocomplete]"></ng-content>
  </div>

  <p class="text-xs text-gray-500 mt-1" *ngIf="hint">{{ hint }}</p>

  <div *ngIf="control?.errors && errorMessages">
    <ng-container *ngFor="let error of control?.errors | keyvalue">
      <p class="mb-1 text-sm text-danger" *ngIf="errorMessages[error.key]?.length > 0">
        {{ errorMessages[error.key] }}
      </p>
    </ng-container>
  </div>
</div>
